import { DEFAULT_CONFIG } from '@src/utils/x-ani';

export const X_ANI_CONFIG = {
  ageAppropriateTips: {
    ...DEFAULT_CONFIG,
    x: -100,
    opacity: 0
  }
};
